/** Segments ordonnés dans un item forfait / groupe / produit (texte vs composition catalogue). */

export const SEGMENT_TEXT = "text";
export const SEGMENT_COMPOSITION = "composition";

/**
 * @param {object} item — item brique (forfait, group, product, part)
 * @returns {Array<{ type: string, text?: string, _localId: string, sort?: number }>}
 */
export function normalizeLayoutSegments(item) {
  const baseId = item._localId || "item";
  const compId = `comp_${baseId}`;

  if (Array.isArray(item.layout_segments) && item.layout_segments.length > 0) {
    const segs = item.layout_segments.map((s, i) => ({
      ...s,
      sort: i,
      _localId:
        s._localId ||
        `${s.type || "seg"}_${baseId}_${i}_${typeof performance !== "undefined" ? performance.now() : Date.now()}`,
    }));
    if (!segs.some((s) => s.type === SEGMENT_COMPOSITION)) {
      segs.push({ type: SEGMENT_COMPOSITION, _localId: compId });
    }
    return segs;
  }

  const legacy = (item.text || "").trim();
  if (legacy) {
    return [
      { type: SEGMENT_COMPOSITION, _localId: compId },
      {
        type: SEGMENT_TEXT,
        text: item.text,
        _localId: `txt_${baseId}_legacy`,
      },
    ];
  }
  return [{ type: SEGMENT_COMPOSITION, _localId: compId }];
}

export function assignSortToSegments(segments) {
  return (segments || []).map((s, i) => ({ ...s, sort: i }));
}

/** Texte unique pour API / commentaire article : blocs texte dans l’ordre des segments. */
export function legacyTextFromSegments(segments) {
  if (!segments || !segments.length) return "";
  const chunks = segments
    .filter((s) => s.type === SEGMENT_TEXT && (s.text || "").trim())
    .map((s) => String(s.text).trim());
  return chunks.length ? chunks.join("\n\n") : "";
}

export function patchItemWithLayoutSegments(item, segments) {
  const ordered = assignSortToSegments(segments);
  const joined = legacyTextFromSegments(ordered);
  return {
    ...item,
    layout_segments: ordered,
    text: joined || null,
  };
}

export function addTextSegmentToItem(item, insertIndex = 0) {
  const segs = normalizeLayoutSegments(item);
  const idx = Math.max(0, Math.min(insertIndex, segs.length));
  const newSeg = {
    type: SEGMENT_TEXT,
    text: "",
    _localId: `txt_${item._localId || "x"}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
  };
  const next = [...segs.slice(0, idx), newSeg, ...segs.slice(idx)];
  return patchItemWithLayoutSegments(item, next);
}
